import React, { PureComponent } from "react";
import { Button } from "react-bootstrap";
import { bootstrapUtils } from "react-bootstrap/lib/utils";

import EventEmitter from "services/event-emitter";
import GetStartedModal from "./modal";
import Auth from "routes/Auth";

bootstrapUtils.bsSizes(["md"], Button);

class GetStartedPage extends PureComponent {
  constructor(props) {
    super(props);

    this.eventemitter = EventEmitter.getInstance();
  }

  handleClick = e => {
    e.preventDefault();
    this.eventemitter.trigger("open-get-started-modal");
  };

  onFinish = () => {
    const routes = {
      ceo: 'ceo',
      pd: 'product-development',
      pm: 'product-marketing',
      op: 'operations',
      fi: 'finance',
      fn: 'finance',
    };
    const { currentRound: round } = this.props;
    const role = Auth.getRole();
    const route = routes[role.toLowerCase()];

    if (this.redirectToDecisions === true) {
      this.props.router.push(`/decisions/${route}?round=${round}&from=get-started`);
    } else {
      this.props.router.push("/start");
    }
  };

  get redirectToDecisions() {
    const { currentRound: round } = this.props;

    return round === 1 && !this.roundIsFinished;
  }

  get roundIsFinished() {
    const { currentRound, rounds } = this.props;
    const round = rounds.find(i => i.number === currentRound);

    return round && (round.should_be_finished === true || round.is_finished) ? true : false;
  }

  render() {
    const { team_color = "#fff", currentRound, roundInUrl } = this.props;
    const activeRound = roundInUrl !== null ? roundInUrl : currentRound;

    return (
      <section className="welcomePage">
        <div className="text-center">
          <h1 className="welcome-header">Welcome to Market Games!</h1>
        </div>
        <GetStartedModal
          className="getStarterModal"
          team_color={team_color}
          activeRound={activeRound}
          onFinish={this.onFinish}
          nextOnLastStep={this.redirectToDecisions}
        />
      </section>
    );
  }
}

export default GetStartedPage;



// WEBPACK FOOTER //
// ./src/components/get-started/page.js